module.exports = __webpack_public_path__ + "img/medal-bg.79137ff4.png";